<template>
    <a-card>
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <a-icon type="qrcode" />
            </a-col>
            <a-col :flex="3" justify="center">
                <p>Auto Scan </p>
            </a-col> 
        </a-row>
        <br/> 
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="6" justify="center">
                <a-switch v-model="isEnabled" />
            </a-col>
            
        </a-row>
    </a-card>
</template>

<script>
export default {
    data () {
        return {
            isEnabled : false
        }
    }
}
</script>

<style scoped>
.icons-list >>> .anticon {
  margin-right: 6px;
  font-size: 24px;
}
</style>
